import { useEffect, useState } from "react";

// An estate agent who is signed in to their dashboard on this origin can have
// their name and email address filled in on the referral form, whichever way
// they arrived, keeping the lead on the address the staff app resolves referral
// codes from. Most visitors are not signed in; /api/session answers that with
// a plain "signed_in: false" rather than an error. Staff viewing an agent's
// dashboard through the staff app are not the agent, so they get no prefill.
//
// Returns { fullName, emailAddress } once the lookup resolves for a signed-in
// estate agent, otherwise null.
export default function useSignedInEstateAgent() {
  const [agent, setAgent] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    fetch("/api/session", { method: "GET", credentials: "same-origin", signal: controller.signal })
      .then((resp) => (resp.ok ? resp.json() : null))
      .then((data) => {
        const session = data?.signed_in ? data.session : null;
        if (session?.session_type !== "estate_agent" || session?.subject_type !== "estate_agent") return;
        setAgent({ fullName: session.full_name || null, emailAddress: session.email_address || null });
      })
      .catch((err) => {
        if (err.name !== "AbortError") console.error("Failed to look up the signed-in estate agent", err);
      });
    return () => controller.abort();
  }, []);

  return agent;
}
